
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.363 17.904a6.05 6.05 0 11-8.557 8.557 6.05 6.05 0 018.557-8.557","fill":"#F9B621"}}),_c('path',{attrs:{"d":"M14.363 17.904a6.05 6.05 0 11-8.557 8.557 6.05 6.05 0 018.557-8.557M15.468 19.482l13.43-6.716M15.468 24.883l13.43 6.716","stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32.784 28.318a1.467 1.467 0 012.632 0l.903 1.831c.214.433.627.733 1.105.803l2.02.293a1.467 1.467 0 01.813 2.503l-1.462 1.426a1.467 1.467 0 00-.422 1.298l.345 2.012a1.467 1.467 0 01-2.128 1.547l-1.808-.95a1.467 1.467 0 00-1.364 0l-1.808.95a1.467 1.467 0 01-2.128-1.547l.345-2.012a1.467 1.467 0 00-.422-1.298l-1.462-1.426a1.467 1.467 0 01.813-2.502l2.02-.294c.478-.07.891-.37 1.105-.803l.903-1.831z","fill":"#62AAD8","stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M38.561 5.805a6.05 6.05 0 11-8.557 8.557 6.05 6.05 0 018.557-8.557","fill":"#62AAD8"}}),_c('path',{attrs:{"d":"M38.561 5.805a6.05 6.05 0 11-8.557 8.557 6.05 6.05 0 018.557-8.557","stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    